import {MaterialEditorHTMLPrinter} from "./materialEditorHTMLPrinter";
import {OwayoMaterial} from "./owayoMaterial";
import {sendPostRequest} from "@k/global/axiosFormWrapper";
import {owayoUtils} from "../owayoUtils";

export class MaterialEditor {
    private material: OwayoMaterial;

    public constructor(material: OwayoMaterial) {
        this.material = material;
    }

    public openEditor() {
        if (document.getElementById('materialEditor') !== null) {
            return;
        }
        const gm = this.material.getMaterialData;
        const floatOrZero = (valuename: string) => gm(valuename) ? parseFloat(gm(valuename)) : "0"
        const varlueOverlayFarben = gm("overlayAnzeigenAufFarbenIntArray") ? gm("overlayAnzeigenAufFarbenIntArray").join() : "";

        const children = [
            MaterialEditorHTMLPrinter.createTextureDiv("bumpMap", gm("bumpMap")),
            MaterialEditorHTMLPrinter.createInputBox("bumpScale", floatOrZero("bumpScale")),
            MaterialEditorHTMLPrinter.createTextureDiv("normalMap", gm("normalMap")),
            MaterialEditorHTMLPrinter.createInputBox("normalScale", floatOrZero("normalScale")),
            MaterialEditorHTMLPrinter.createTextureDiv("alphaMap", gm("alphaMap")),
            MaterialEditorHTMLPrinter.createTextureDiv("specularMap", gm("specularMap")),
            MaterialEditorHTMLPrinter.createInputBox("shininess", floatOrZero("shininess")),
            MaterialEditorHTMLPrinter.createInputBox("specular", floatOrZero("specular")),
            MaterialEditorHTMLPrinter.createInputBox("specularMin", floatOrZero("specularMin")),
            MaterialEditorHTMLPrinter.createInputVec2("scaleStoff", gm("scaleStoff")),
            MaterialEditorHTMLPrinter.createCheckBox("overrideScale", gm("overrideScale")),
            MaterialEditorHTMLPrinter.createTextureDiv("overlayMap", gm("overlayMap")),
            MaterialEditorHTMLPrinter.createInputVec2("overlayScale", gm("overlayScale")),
            MaterialEditorHTMLPrinter.createInputBox("overlayIntensity", floatOrZero("overlayIntensity")),
            MaterialEditorHTMLPrinter.createInputBox("overlayHelligkeitsSummand", floatOrZero("overlayHelligkeitsSummand")),
            MaterialEditorHTMLPrinter.createInputBoxForArrayData("overlayAnzeigenAufFarbenIntArray", varlueOverlayFarben),
            MaterialEditorHTMLPrinter.createCheckBox("innenseiteAufhellen", gm("innenseiteAufhellen")),
            MaterialEditorHTMLPrinter.createCheckBox("schwarzAufhellenImDruckbereich", gm("schwarzAufhellenImDruckbereich"))

        ];
        MaterialEditorHTMLPrinter.createEditor(this.material.getName(), children);
        this.setClickHandlers();
    }

    private textureFileInputChanged(input:HTMLInputElement) {
        const self = this;
        const textureName = input.dataset.texturename;
        const reader = new FileReader();
        reader.onloadend = function () {
            self.material.setMaterialData(textureName, (reader.result as string).substring((reader.result as string).indexOf(',') + 1));
            $(".texture-image[data-texturename=" + textureName + "]").attr("src", (reader.result) as string);
            $(".textureInput[data-texturename=" + textureName + "]").removeClass("emptyTexture")
            self.material.textureChanged();
        };
        reader.readAsDataURL(input.files[0]);
    }

    private clearTexture(input:HTMLInputElement) {
        const textureName = input.dataset.texturename;
        this.material.setMaterialData(textureName, "");
        $(".texture-image[data-texturename=" + textureName + "]").attr("src", "");
        $(".textureInput[data-texturename=" + textureName + "]").addClass("emptyTexture")

        this.material.textureChanged();
    }

    public saveMaterial() {
        sendPostRequest("/konfigurator_php/debug/writeMaterialJSON.php", {
            name: owayoUtils.getCleanPartName(this.material.getName()).toLowerCase(),
            data: JSON.stringify(this.material.getMaterialData(), null, 2)
        })
            .then(() => alert('saved.')).catch(() => alert('Failed!'))
    }

    private setClickHandlers() {
        $(".textureInput .fileinput").on("change", (e) => this.textureFileInputChanged(e.currentTarget as HTMLInputElement));
        $(".materialeditor_cleartexture").click((e) => this.clearTexture(e.currentTarget as HTMLInputElement))
        $(".textureinput_singleinput").change(e => {
            const valuename = e.currentTarget.dataset.valuename;
            this.material.setMaterialData(valuename, parseFloat((e.currentTarget as HTMLInputElement).value))
        })

        $(".textureinput_componentinput").change(e => {
            const valuename = e.currentTarget.dataset.valuename;
            const component = e.currentTarget.dataset.component as "x" | "y";
            this.material.setMaterialDataVec2Component(valuename, component, parseFloat((e.currentTarget as HTMLInputElement).value))
        })

        $(".textureinput_arrayinput").change(e => {
            const valuename = e.currentTarget.dataset.valuename;
            // @ts-ignore
            this.material.setMaterialData(valuename, ((e.currentTarget as HTMLInputElement).value as string).replaceAll(/\s/g, "").split(",").filter(s => s !== "").map(v => parseInt(v)));
        })
        $(".textureinput_checkbox").click((e) => this.material.setMaterialData(e.currentTarget.dataset.valuename, (e.currentTarget as HTMLInputElement).checked))

        $('#materialEditorClose').click(() => $('#materialEditor').remove());
        $('#materialEditorSave').click(() => this.saveMaterial());
    }

}
